const news = {
    'zh-tw': "最新消息",
    en: "",
    children: {}
}
const news_type = {
    'zh-tw': "最新消息分類",
    en: "",
    children: {}

}
const sigle_new = {
    'zh-tw': "消息",
    en: "",
    children: {}

}
const no_permission = {
    'zh-tw': "沒有權限",
    en: "No Permission",
    children: {
        no_access_permission: {
            'zh-tw': "無權限檢視",
            en: "No Access Permission",
        },
        no_access_message: {
            'zh-tw': "您的帳戶沒有權限檢視此頁面。請聯繫系統管理員獲取檢視權限。",
            en: "Your account does not have permission to access this page. Please contact the system administrator for access.",
        },
        return_home: {
            'zh-tw': "返回首頁",
            en: "Return to Home",
        }
    }

}
const login_required = {
    'zh-tw': "需要登入",
    en: "Login Required",
    children: {
        login_required: {
            'zh-tw': "需要登入",
            en: "Login Required",
        },
        login_message: {
            'zh-tw': "您需要登入才能檢視此頁面。請登入或註冊一個新帳號。",
            en: "You need to log in to access this page. Please log in or register a new account.",
        },
        login: {
            'zh-tw': "登入",
            en: "Login",
        },
        return_home: {
            'zh-tw': "返回首頁",
            en: "Return to Home",
        }
    }

}
const language_utility = {
    'zh-tw': "需要登入",
    en: "Login Required",
    children:{
        news: {
            ...news
        },
        news_type: {
            ...news_type
        },
        new: {
            ...sigle_new
        },
        no_permission: no_permission,
        login_required: login_required
    }
   
}



export {
    language_utility
}